// @ts-check

/**
 * Whether an event field has a value to show.
 * A field mapped with `ShowOnlyWhenTrue` shows only when its value is true, so a live ping never reads as cached.
 * A boolean in an event's numeric values arrives as 1 or 0, so 1 counts as true.
 * @param {{ ShowOnlyWhenTrue?: boolean } | undefined} fieldMetadata
 * @param {unknown} value
 * @returns {boolean}
 */
export function isEventFieldShown(fieldMetadata, value) {
  if (value === '') {
    return false;
  }
  if (fieldMetadata?.ShowOnlyWhenTrue) {
    const text = String(value).toLowerCase();
    return text === 'true' || text === '1';
  }
  return true;
}
